<div class="banner-section" [ngClass]="{'mt-75': !isMobile, 'mt-60': (isMobile && userData) || (!userData && isMobile)}">
  <div *ngIf="!userData && storageService.getFromSession('dm_page_visited')" class="top-banner">
    <app-module-loader [load]="true" moduleId="sip-pitch-banner-v2" selector="app-sip-pitch-banner-v2"
                        [inputs]="{
                        config: {
                        text: 'Save A Life Every Month With Ketto SIP!',
                        button: 'Start Monthly Giving',
                        utm_source: 'utm_internal',
                        utm_medium: 'Homepage',
                        utm_content: 'top_nudge'}}">
    </app-module-loader>
  </div>
  <div class="sip-top-banner-wrapper download-app" *ngIf="!isMobile && userData">
    <app-download-app-banner [config]="{v: 6, title: isAnyActiveSip ? 'Manage monthly donations' : 'Track your donations on the go'}"></app-download-app-banner>
  </div>
  <div class="sip-top-banner-wrapper download-app" *ngIf="!isMobile && !userData && vwo.banner_anniversary_AB()">
    <app-download-app-banner [config]="{v: 8}"></app-download-app-banner>
  </div>
  <div class="sip-top-banner-wrapper story-app" *ngIf="!isMobile && !userData && vwo.story_promo_homeAB()">
    <app-story-promo-banner [config]="{theme: 'v1'}"></app-story-promo-banner>
  </div>
  <div class="banner-img">
    <img loading="lazy" [attr.data-src]="banners[0]?.desktop?.cdn_path" class="d-none d-lg-block d-md-block d-sm-block" [default]="utilService.defaultImg" [alt]="banners[0]?.title"/>
    <img loading="lazy" [attr.data-src]="banners[0]?.mobile?.cdn_path" class="d-block d-lg-none d-md-none d-sm-none" [default]="utilService.defaultImg" [alt]="banners[0]?.title"/>
  </div>
  <div class="title-section">
    <div>
      <div class="questions-title">
        <h2>{{banners[0]?.title}}</h2>
        <app-raised-donors-fr></app-raised-donors-fr>
        <div inViewport (inViewportAction)="whatsappToggle($event)" class="sac-wrapper">
          <app-startfundraiser-button pageName="home" info2="home_1" [width]="isMobile ? '100%' : '290px'" height="60px"
            lineHeight="30px" font="20px" label="Start a Fundraiser for FREE"></app-startfundraiser-button>
        </div>
        <div class="hindi-sac" (click)="hindiSAC()">
          {{alternateLangSAC}} <i class="material-icons">keyboard_arrow_right</i>

        </div>
        <hr class="separator d-block d-lg-none d-md-none d-sm-none" />
      </div>
    </div>
  </div>
  <div *ngIf="isUrgentFundraiser" class="urgent-wrapper">
    <!-- <app-urgent-fr-main [urgentFrData]="urgentFrData"></app-urgent-fr-main> -->
    <app-homepage-sip-banner [fundraiser]="urgentFrData[0]"></app-homepage-sip-banner>
  </div>
</div>

<div #whatsAppSticky class="d-lg-none d-md-none" (click)="pushWhatsappEvent($event)">
  <a href="javascript:void(0)" class="whatsapp-share-unstick" mat-raised-button><i class="icon-whatsapp"></i>Start a Fundraiser on Whatsapp</a>
</div>

<div class="d-none d-lg-block" [class.fixed-dock]="navIsFixed">
  <!-- Start Fundraiser Doc on footer -->
  <app-start-fundraiser-widget></app-start-fundraiser-widget>
</div>
